<NConfigProvider :theme-overrides="naiveThemeOverrides"><Component :is="layout"></Component></NConfigProvider>